/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistQrRouteImport } from './routes/waitlist-qr'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SelectLocationRouteImport } from './routes/select-location'
import { Route as ReservasRouteImport } from './routes/reservas'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CotizacionesRouteImport } from './routes/cotizaciones'
import { Route as ClienteRouteImport } from './routes/cliente'
import { Route as IndexRouteImport } from './routes/index'

const WaitlistQrRoute = WaitlistQrRouteImport.update({
  id: '/waitlist-qr',
  path: '/waitlist-qr',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectLocationRoute = SelectLocationRouteImport.update({
  id: '/select-location',
  path: '/select-location',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservasRoute = ReservasRouteImport.update({
  id: '/reservas',
  path: '/reservas',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CotizacionesRoute = CotizacionesRouteImport.update({
  id: '/cotizaciones',
  path: '/cotizaciones',
  getParentRoute: () => rootRouteImport,
} as any)
const ClienteRoute = ClienteRouteImport.update({
  id: '/cliente',
  path: '/cliente',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cliente': typeof ClienteRoute
  '/cotizaciones': typeof CotizacionesRoute
  '/login': typeof LoginRoute
  '/reservas': typeof ReservasRoute
  '/select-location': typeof SelectLocationRoute
  '/settings': typeof SettingsRoute
  '/waitlist-qr': typeof WaitlistQrRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cliente': typeof ClienteRoute
  '/cotizaciones': typeof CotizacionesRoute
  '/login': typeof LoginRoute
  '/reservas': typeof ReservasRoute
  '/select-location': typeof SelectLocationRoute
  '/settings': typeof SettingsRoute
  '/waitlist-qr': typeof WaitlistQrRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cliente': typeof ClienteRoute
  '/cotizaciones': typeof CotizacionesRoute
  '/login': typeof LoginRoute
  '/reservas': typeof ReservasRoute
  '/select-location': typeof SelectLocationRoute
  '/settings': typeof SettingsRoute
  '/waitlist-qr': typeof WaitlistQrRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cliente'
    | '/cotizaciones'
    | '/login'
    | '/reservas'
    | '/select-location'
    | '/settings'
    | '/waitlist-qr'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cliente'
    | '/cotizaciones'
    | '/login'
    | '/reservas'
    | '/select-location'
    | '/settings'
    | '/waitlist-qr'
  id:
    | '__root__'
    | '/'
    | '/cliente'
    | '/cotizaciones'
    | '/login'
    | '/reservas'
    | '/select-location'
    | '/settings'
    | '/waitlist-qr'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClienteRoute: typeof ClienteRoute
  CotizacionesRoute: typeof CotizacionesRoute
  LoginRoute: typeof LoginRoute
  ReservasRoute: typeof ReservasRoute
  SelectLocationRoute: typeof SelectLocationRoute
  SettingsRoute: typeof SettingsRoute
  WaitlistQrRoute: typeof WaitlistQrRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist-qr': {
      id: '/waitlist-qr'
      path: '/waitlist-qr'
      fullPath: '/waitlist-qr'
      preLoaderRoute: typeof WaitlistQrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-location': {
      id: '/select-location'
      path: '/select-location'
      fullPath: '/select-location'
      preLoaderRoute: typeof SelectLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservas': {
      id: '/reservas'
      path: '/reservas'
      fullPath: '/reservas'
      preLoaderRoute: typeof ReservasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cotizaciones': {
      id: '/cotizaciones'
      path: '/cotizaciones'
      fullPath: '/cotizaciones'
      preLoaderRoute: typeof CotizacionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cliente': {
      id: '/cliente'
      path: '/cliente'
      fullPath: '/cliente'
      preLoaderRoute: typeof ClienteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClienteRoute: ClienteRoute,
  CotizacionesRoute: CotizacionesRoute,
  LoginRoute: LoginRoute,
  ReservasRoute: ReservasRoute,
  SelectLocationRoute: SelectLocationRoute,
  SettingsRoute: SettingsRoute,
  WaitlistQrRoute: WaitlistQrRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
